import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _Promise from '/app/node_modules/babel-runtime/core-js/promise';
import _Object$defineProperty from '/app/node_modules/babel-runtime/core-js/object/define-property';
import _Object$assign from '/app/node_modules/babel-runtime/core-js/object/assign';
import _extends from '/app/node_modules/babel-runtime/helpers/extends';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';

var createApp = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ssrContext) {
    var _this = this;

    var router, store, app, next, route, path, inject;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            router = createRouter(ssrContext);
            store = createStore(ssrContext);
            // Add this.$router into store actions/mutations

            store.$router = router;

            // Create Root instance
            // here we inject the router and store to all child components,
            // making them available everywhere as `this.$router` and `this.$store`.
            app = _extends({
              router: router,
              store: store,
              nuxt: {
                defaultTransition: defaultTransition,
                transitions: [defaultTransition],
                setTransitions: function setTransitions(transitions) {
                  if (!Array.isArray(transitions)) {
                    transitions = [transitions];
                  }
                  transitions = transitions.map(function (transition) {
                    if (!transition) {
                      transition = defaultTransition;
                    } else if (typeof transition === 'string') {
                      transition = _Object$assign({}, defaultTransition, { name: transition });
                    } else {
                      transition = _Object$assign({}, defaultTransition, transition);
                    }
                    return transition;
                  });
                  this.$options.nuxt.transitions = transitions;
                  return transitions;
                },

                err: null,
                dateErr: null,
                error: function error(err) {
                  err = err || null;
                  app.context._errored = !!err;
                  if (typeof err === 'string') err = { statusCode: 500, message: err };
                  var nuxt = this.nuxt || this.$options.nuxt;
                  nuxt.dateErr = Date.now();
                  nuxt.err = err;
                  // Used in lib/server.js
                  if (ssrContext) ssrContext.nuxt.error = err;
                  return err;
                }
              }
            }, App);

            // Make app available into store via this.app

            store.app = app;

            next = ssrContext ? ssrContext.next : function (location) {
              return app.router.push(location);
            };
            // Resolve route

            route = void 0;

            if (ssrContext) {
              route = router.resolve(ssrContext.url).route;
            } else {
              path = getLocation(router.options.base);

              route = router.resolve(path).route;
            }

            // Set context to app.context
            _context2.next = 10;
            return setContext(app, {
              route: route,
              next: next,
              error: app.nuxt.error.bind(app),
              store: store,
              payload: ssrContext ? ssrContext.payload : undefined,
              req: ssrContext ? ssrContext.req : undefined,
              res: ssrContext ? ssrContext.res : undefined,
              beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined
            });

          case 10:
            inject = function inject(key, value) {
              if (!key) throw new Error('inject(key, value) has no key provided');
              if (!value) throw new Error('inject(key, value) has no value provided');
              key = '$' + key;
              // Add into app
              app[key] = value;

              // Add into store
              store[key] = app[key];

              // Check if plugin not already installed
              var installKey = '__nuxt_' + key + '_installed__';
              if (Vue[installKey]) return;
              Vue[installKey] = true;
              // Call Vue.use() to install the plugin into vm
              Vue.use(function () {
                if (!Vue.prototype.hasOwnProperty(key)) {
                  _Object$defineProperty(Vue.prototype, key, {
                    get: function get() {
                      return this.$root.$options[key];
                    }
                  });
                }
              });
            };

            if (process.browser) {
              // Replace store state before plugins execution
              if (window.__NUXT__ && window.__NUXT__.state) {
                store.replaceState(window.__NUXT__.state);
              }
            }

            // Plugin execution

            if (!(typeof nuxt_plugin_axios_80c87b74 === 'function')) {
              _context2.next = 15;
              break;
            }

            _context2.next = 15;
            return nuxt_plugin_axios_80c87b74(app.context, inject);

          case 15:
            if (!(typeof nuxt_plugin_store_336ed1aa === 'function')) {
              _context2.next = 18;
              break;
            }

            _context2.next = 18;
            return nuxt_plugin_store_336ed1aa(app.context, inject);

          case 18:
            if (!(typeof nuxt_plugin_vuetify_165b1c58 === 'function')) {
              _context2.next = 21;
              break;
            }

            _context2.next = 21;
            return nuxt_plugin_vuetify_165b1c58(app.context, inject);

          case 21:
            if (!(typeof nuxt_plugin_vuelidate_4345260a === 'function')) {
              _context2.next = 24;
              break;
            }

            _context2.next = 24;
            return nuxt_plugin_vuelidate_4345260a(app.context, inject);

          case 24:
            if (!(typeof nuxt_plugin_eventbus_719ef217 === 'function')) {
              _context2.next = 27;
              break;
            }

            _context2.next = 27;
            return nuxt_plugin_eventbus_719ef217(app.context, inject);

          case 27:
            if (!(typeof nuxt_plugin_onlogout_674f5282 === 'function')) {
              _context2.next = 30;
              break;
            }

            _context2.next = 30;
            return nuxt_plugin_onlogout_674f5282(app.context, inject);

          case 30:
            if (!(typeof nuxt_plugin_axios_3566aa80 === 'function')) {
              _context2.next = 33;
              break;
            }

            _context2.next = 33;
            return nuxt_plugin_axios_3566aa80(app.context, inject);

          case 33:
            if (!(typeof nuxt_plugin_axiosdownload_9cec8e16 === 'function')) {
              _context2.next = 36;
              break;
            }

            _context2.next = 36;
            return nuxt_plugin_axiosdownload_9cec8e16(app.context, inject);

          case 36:
            if (!(typeof nuxt_plugin_authcookie_2f89a8f3 === 'function')) {
              _context2.next = 39;
              break;
            }

            _context2.next = 39;
            return nuxt_plugin_authcookie_2f89a8f3(app.context, inject);

          case 39:
            if (!(typeof nuxt_plugin_sweetalert_4d5e1f3c === 'function')) {
              _context2.next = 42;
              break;
            }

            _context2.next = 42;
            return nuxt_plugin_sweetalert_4d5e1f3c(app.context, inject);

          case 42:
            if (!(typeof nuxt_plugin_sweetalert2_50cd1c10 === 'function')) {
              _context2.next = 45;
              break;
            }

            _context2.next = 45;
            return nuxt_plugin_sweetalert2_50cd1c10(app.context, inject);

          case 45:
            if (!(typeof nuxt_plugin_sharedcomponents_ad92fe70 === 'function')) {
              _context2.next = 48;
              break;
            }

            _context2.next = 48;
            return nuxt_plugin_sharedcomponents_ad92fe70(app.context, inject);

          case 48:
            if (!(typeof nuxt_plugin_moment_4f74a614 === 'function')) {
              _context2.next = 51;
              break;
            }

            _context2.next = 51;
            return nuxt_plugin_moment_4f74a614(app.context, inject);

          case 51:
            if (!(typeof nuxt_plugin_vueautocomplete_d0b03776 === 'function')) {
              _context2.next = 54;
              break;
            }

            _context2.next = 54;
            return nuxt_plugin_vueautocomplete_d0b03776(app.context, inject);

          case 54:
            if (!(typeof nuxt_plugin_fontawesome_b8db358e === 'function')) {
              _context2.next = 57;
              break;
            }

            _context2.next = 57;
            return nuxt_plugin_fontawesome_b8db358e(app.context, inject);

          case 57:
            if (!process.browser) {
              _context2.next = 67;
              break;
            }

            if (!(typeof nuxt_plugin_vuelazyload_37761242 === 'function')) {
              _context2.next = 61;
              break;
            }

            _context2.next = 61;
            return nuxt_plugin_vuelazyload_37761242(app.context, inject);

          case 61:
            if (!(typeof nuxt_plugin_vueairbnbstyledatepicker_49108b08 === 'function')) {
              _context2.next = 64;
              break;
            }

            _context2.next = 64;
            return nuxt_plugin_vueairbnbstyledatepicker_49108b08(app.context, inject);

          case 64:
            if (!(typeof nuxt_plugin_vuethemask_ab289cb6 === 'function')) {
              _context2.next = 67;
              break;
            }

            _context2.next = 67;
            return nuxt_plugin_vuethemask_ab289cb6(app.context, inject);

          case 67:
            if (!(process.server && ssrContext && ssrContext.url)) {
              _context2.next = 70;
              break;
            }

            _context2.next = 70;
            return new _Promise(function (resolve, reject) {
              router.push(ssrContext.url, resolve, function () {
                // navigated to a different route in router guard
                var unregister = router.afterEach(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(to, from, next) {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            ssrContext.url = to.fullPath;
                            _context.next = 3;
                            return getRouteData(to);

                          case 3:
                            app.context.route = _context.sent;

                            app.context.params = to.params || {};
                            app.context.query = to.query || {};
                            unregister();
                            resolve();

                          case 8:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x2, _x3, _x4) {
                    return _ref2.apply(this, arguments);
                  };
                }());
              });
            });

          case 70:
            return _context2.abrupt('return', {
              app: app,
              router: router,
              store: store
            });

          case 71:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function createApp(_x) {
    return _ref.apply(this, arguments);
  };
}();

import 'es6-promise/auto';
import Vue from 'vue';
import Meta from 'vue-meta';
import { createRouter } from './router.js';
import NoSSR from './components/no-ssr.js';
import NuxtChild from './components/nuxt-child.js';
import NuxtLink from './components/nuxt-link.js';
import NuxtError from '../src/layouts/error.vue';
import Nuxt from './components/nuxt.js';
import App from './App.js';
import { setContext, getLocation, getRouteData } from './utils';
import { createStore } from './store.js';

/* Plugins */
import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74'; // Source: ./axios.js
import nuxt_plugin_store_336ed1aa from 'nuxt_plugin_store_336ed1aa'; // Source: ../src/plugins/store
import nuxt_plugin_vuetify_165b1c58 from 'nuxt_plugin_vuetify_165b1c58'; // Source: ../src/plugins/vuetify
import nuxt_plugin_vuelidate_4345260a from 'nuxt_plugin_vuelidate_4345260a'; // Source: ../src/plugins/vuelidate
import nuxt_plugin_eventbus_719ef217 from 'nuxt_plugin_eventbus_719ef217'; // Source: ../src/plugins/event-bus
import nuxt_plugin_onlogout_674f5282 from 'nuxt_plugin_onlogout_674f5282'; // Source: ../src/plugins/on-logout
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80'; // Source: ../src/plugins/axios
import nuxt_plugin_axiosdownload_9cec8e16 from 'nuxt_plugin_axiosdownload_9cec8e16'; // Source: ../src/plugins/axios-download
import nuxt_plugin_authcookie_2f89a8f3 from 'nuxt_plugin_authcookie_2f89a8f3'; // Source: ../src/plugins/auth-cookie
import nuxt_plugin_sweetalert_4d5e1f3c from 'nuxt_plugin_sweetalert_4d5e1f3c'; // Source: ../src/plugins/sweetalert
import nuxt_plugin_sweetalert2_50cd1c10 from 'nuxt_plugin_sweetalert2_50cd1c10'; // Source: ../src/plugins/sweetalert2
import nuxt_plugin_sharedcomponents_ad92fe70 from 'nuxt_plugin_sharedcomponents_ad92fe70'; // Source: ../src/plugins/shared-components
import nuxt_plugin_moment_4f74a614 from 'nuxt_plugin_moment_4f74a614'; // Source: ../src/plugins/moment
import nuxt_plugin_vueautocomplete_d0b03776 from 'nuxt_plugin_vueautocomplete_d0b03776'; // Source: ../src/plugins/vue-autocomplete
import nuxt_plugin_fontawesome_b8db358e from 'nuxt_plugin_fontawesome_b8db358e'; // Source: ../src/plugins/fontawesome.js
import nuxt_plugin_vuelazyload_37761242 from 'nuxt_plugin_vuelazyload_37761242'; // Source: ../src/plugins/vue-lazyload.js (ssr: false)
import nuxt_plugin_vueairbnbstyledatepicker_49108b08 from 'nuxt_plugin_vueairbnbstyledatepicker_49108b08'; // Source: ../src/plugins/vue-airbnb-style-datepicker (ssr: false)
import nuxt_plugin_vuethemask_ab289cb6 from 'nuxt_plugin_vuethemask_ab289cb6'; // Source: ../src/plugins/vue-the-mask (ssr: false)


// Component: <no-ssr>
Vue.component(NoSSR.name, NoSSR);

// Component: <nuxt-child>
Vue.component(NuxtChild.name, NuxtChild);

// Component: <nuxt-link>
Vue.component(NuxtLink.name, NuxtLink);

// Component: <nuxt>`
Vue.component(Nuxt.name, Nuxt);

// vue-meta configuration
Vue.use(Meta, {
  keyName: 'head', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-n-head', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-n-head-ssr', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'hid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
});

var defaultTransition = { "name": "page", "mode": "out-in", "appear": false, "appearClass": "appear", "appearActiveClass": "appear-active", "appearToClass": "appear-to" };

export { createApp, NuxtError };


//////////////////
// WEBPACK FOOTER
// ./.nuxt/index.js
// module id = ./.nuxt/index.js
// module chunks = 34